import {
  CancelableQueryViewArgs,
  query,
  Query,
  QueryHandlerFunction,
  QueryHandlerFunctionArgs,
} from "@lookiero/messaging";
import { CheckoutFeedbackQuestionProjection } from "./checkoutFeedback";

const VIEW_CHECKOUT_FEEDBACK_DEFINITION_BY_CHECKOUT_ID = "view_checkout_feedback_definition_by_checkout_id";

interface ViewCheckoutFeedbackDefinitionByCheckoutIdPayload {
  readonly checkoutId: string;
}

interface ViewCheckoutFeedbackDefinitionByCheckoutId
  extends
    Query<typeof VIEW_CHECKOUT_FEEDBACK_DEFINITION_BY_CHECKOUT_ID>,
    ViewCheckoutFeedbackDefinitionByCheckoutIdPayload {}

interface ViewCheckoutFeedbackDefinitionByCheckoutIdFunction {
  (payload: ViewCheckoutFeedbackDefinitionByCheckoutIdPayload): ViewCheckoutFeedbackDefinitionByCheckoutId;
}

const viewCheckoutFeedbackDefinitionByCheckoutId: ViewCheckoutFeedbackDefinitionByCheckoutIdFunction = (payload) => ({
  ...query({ name: VIEW_CHECKOUT_FEEDBACK_DEFINITION_BY_CHECKOUT_ID }),
  ...payload,
});

type ViewCheckoutFeedbackDefinitionByCheckoutIdResult = CheckoutFeedbackQuestionProjection[] | null;

interface CheckoutFeedbackDefinitionByCheckoutIdViewArgs extends CancelableQueryViewArgs {
  readonly checkoutId: string;
}

interface CheckoutFeedbackDefinitionByCheckoutIdView {
  (args: CheckoutFeedbackDefinitionByCheckoutIdViewArgs): Promise<ViewCheckoutFeedbackDefinitionByCheckoutIdResult>;
}

interface ViewCheckoutFeedbackDefinitionByCheckoutIdHandlerFunctionArgs extends QueryHandlerFunctionArgs {
  readonly view: CheckoutFeedbackDefinitionByCheckoutIdView;
}

const viewCheckoutFeedbackDefinitionByCheckoutIdHandler: QueryHandlerFunction<
  ViewCheckoutFeedbackDefinitionByCheckoutId,
  ViewCheckoutFeedbackDefinitionByCheckoutIdResult,
  ViewCheckoutFeedbackDefinitionByCheckoutIdHandlerFunctionArgs
> =
  ({ view, signal }) =>
  async ({ checkoutId }) =>
    view({ checkoutId, signal });

export type {
  ViewCheckoutFeedbackDefinitionByCheckoutId,
  CheckoutFeedbackDefinitionByCheckoutIdView,
  ViewCheckoutFeedbackDefinitionByCheckoutIdResult,
};
export {
  VIEW_CHECKOUT_FEEDBACK_DEFINITION_BY_CHECKOUT_ID,
  viewCheckoutFeedbackDefinitionByCheckoutId,
  viewCheckoutFeedbackDefinitionByCheckoutIdHandler,
};
